import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { Image } from '../../common/image'
import classes from '../index.module.scss'
import chaseMoneyIcon from '../orderInformation/components/chaseMoney.svg'

export const CheckOutButton = ({ isDisableCheckout, onCheckOut }) => {
  return (
    <Element
      style={{
        backgroundColor: '#3DA967',
        color: '#FFFFFF',
        marginTop: -8,
        opacity: isDisableCheckout ? 0.4 : 1,
      }}
      className={classes.btnSubmit}
      onClick={onCheckOut}
    >
      <Image
        src={chaseMoneyIcon}
        alt="chaseMoney"
        style={{ width: 18, height: 18 }}
        className={classes.mr4}
      />
      <Translate value="cartAndOrders.cart.checkout" />
    </Element>
  )
}
